import { useEffect, useState } from "react";
import track from "../helpers/track";
import { metadata } from "../content/copy";

// const API_URL = "http://localhost:8010/proxy/bias-decoder-service";
// const API_URL = "/bias-decoder-service";

// const API_URL = process.env.REACT_APP_API_URL ;

const API_URL = window.bwSettings.apiURL;

const cache = {};
let prevRequest = null;

const sources = {
  ac: "landing-page-appcast",
  tj: "landing-page-tj",
  ss: "landing-page-stst",
};

const useAPI = (text) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const trimmed = text.trim();

    if (trimmed === "") {
      return setResponse(null);
    }

    if (cache[trimmed]) {
      setResponse(cache[trimmed]);
      return;
    }

    const fetchData = async () => {
      setError(null);
      setIsLoading(true);

      try {
        // Cancel prev request if required
        if (prevRequest) {
          prevRequest();
        }

        const controller = new AbortController();
        const signal = controller.signal;
        prevRequest = () => controller.abort();

        const res = await fetch(`${API_URL}/prediction`, {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            text: trimmed,
            language: metadata.lang,
            source: sources[process.env.REACT_APP_STYLE],
          }),
          signal,
        });

        if (!res.ok) {
          throw new Error("Something went wrong.");
        }

        const json = await res.json();
        prevRequest = null;
        cache[trimmed] = json;

        track.apiResponse(json.response_id, json.metrics);

        setResponse(json);
        setIsLoading(false);
      } catch (error) {
        console.log(error);

        if (error.name !== "AbortError") {
          setIsLoading(false);
          setError(error);
        }
      }
    };
    fetchData();
  }, [text]);

  return { response, error, isLoading };
};

export default useAPI;
